import { Modal, PlainModalProps } from '@design-system/components/modal/modal';
import { useState } from 'react';
import { ExclusivePriceSetupProps } from '@client/new/common/selfServeExclusive/exclusivePriceSetup';
import { SubscriptionPriceSelection } from '../../creator/home/components/offerModal/SubscriptionPriceSelection';
import { SubscriptionSummary } from '../../creator/home/components/offerModal/SubscriptionSummary';
import { Summary } from '../../creator/home/components/offerModal/Summary';

type InitialSubscriptionPriceModalProps = Pick<
  PlainModalProps,
  'isOpen' | 'onClose'
> & {
  createProgram: () => void;
  savePricing: (callback?: () => void) => void;
  exclusive: ExclusivePriceSetupProps;
  errors?: string[];
};

export const InitialSubscriptionPriceModal = (
  props: InitialSubscriptionPriceModalProps,
) => (
  <Modal
    {...props}
    modalClassName="w-full h-full md:w-[80%] md:h-[80%]"
    contentClassName="w-full h-full gap-0"
    disableBackdropClick
  >
    <Content {...props} />
  </Modal>
);

type SetupStep = 'SubscriptionPrice' | 'SubscriptionSummary' | 'Summary';

const Content = (props: InitialSubscriptionPriceModalProps) => {
  const [step, setStep] = useState<SetupStep>('SubscriptionPrice');

  switch (step) {
    case 'SubscriptionPrice':
      return (
        <SubscriptionPriceSelection
          next={() => setStep('SubscriptionSummary')}
          savePricing={props.savePricing}
          max={3}
          step={1}
          errors={props.errors}
          {...props.exclusive}
        />
      );
    case 'SubscriptionSummary': {
      return (
        <SubscriptionSummary
          next={() => setStep('Summary')}
          back={() => setStep('SubscriptionPrice')}
          max={3}
          step={2}
          monthly={props.exclusive.monthly}
          annual={props.exclusive.annual}
        />
      );
    }
    case 'Summary': {
      return (
        <Summary
          next={() => props.createProgram()}
          back={() => setStep('SubscriptionSummary')}
          version="subscription"
          max={3}
          step={3}
        />
      );
    }
  }
};
